import { Button, Grid } from '@material-ui/core'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { EnumClientTypes } from '../../api/Argentia/enums/enumClientTypes'
import Page from '../../components/page/page'
import PageHeader from '../../components/page/pageHeader'
import { usePageState } from '../../hooks'
import { GlobalNotification, NonAuthRoutes } from '../../model'
import { ProductsTable } from './components/productsTable/productsTable'

export interface ProductsPageProps {
  location: { state: { clientType: EnumClientTypes } }
}

export const ProductsPage: React.FC<ProductsPageProps> = props => {
  const [t] = useTranslation(['globalerisLibrary', 'products', 'enums', 'clientsMod'])
  const history = useHistory()

  const clientType = props.location.state?.clientType ?? EnumClientTypes.FINAL_CLIENT

  const [isFetching, setIsFetching] = useState<boolean>(false)

  const { dataTableFilter, dataTableSearch, dateFilter, customFilter, activeTab } = usePageState()

  const [globalNotification, setGlobalNotification] = useState<GlobalNotification | undefined>(
    undefined
  )

  // Hooks Region Starts

  // Hooks Region Ends

  // Handlers Region Starts

  const onTableFetching = (childIsFetching: boolean) => {
    setIsFetching(childIsFetching)
  }

  // Handlers Region Ends

  // Functions Region Starts

  // Functions Region Ends

  return (
    <Page notification={globalNotification}>
      <PageHeader title={t('products:title')}>
        <Button
          size="small"
          variant="text"
          color="primary"
          onClick={() => {
            history.push(NonAuthRoutes.Client)
          }}
        >
          {t('clientsMod:buttons.back')}
        </Button>
        <Button
          size="small"
          variant="contained"
          disabled={isFetching}
          color="primary"
          onClick={() => {
            switch (clientType) {
              case EnumClientTypes.WHOLESALER:
                history.push(NonAuthRoutes.ProductMay)
                break
              case EnumClientTypes.COMMERCIAL:
                history.push(NonAuthRoutes.ProductDataCommercial)
                break
              default:
                history.push(NonAuthRoutes.ProductData)
                break
            }
          }}
        >
          {t('clientsMod:buttons.oldProductPage')}
        </Button>
      </PageHeader>
      <ProductsTable
        clientType={clientType}
        dataTableFilter={dataTableFilter}
        customFilter={customFilter}
        dataTableSearch={dataTableSearch}
        onFetching={onTableFetching}
      ></ProductsTable>
    </Page>
  )
}
